// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.custom-extension-modal_modal-content_PD3ub {
    max-width: 990px;
    margin-top: 50px;
}

.custom-extension-modal_modal-content-min_ntNCd {
    max-width: 550px;
    margin-top: 50px;
}

.custom-extension-modal_body_SyyBd {
    background: var(--ui-white);
    padding: 1.5rem 2.25rem;
    display: flex;
    flex-direction: row;
}

.custom-extension-modal_loadUI_M788u {
    flex: 1;
    min-width: 300px;
}

.custom-extension-modal_viewUI_ifnqN {
    flex: 1;
    min-width: 300px;
    overflow-y: auto;
    max-height: 500px;
}

.custom-extension-modal_svgList_pojnv {
    display: flex;
    flex-direction: column;
}

.custom-extension-modal_svgItem_M8DGF{
    margin-bottom: -75px;
}

.custom-extension-modal_body_SyyBd p,
.custom-extension-modal_unsandboxed-container_qNk5Y,
.custom-extension-modal_url-input_jC64Z,
.custom-extension-modal_text-code-input_bToYJ {
    margin: 1rem 0;
    display: block;
}

.custom-extension-modal_type-selector-container_UB6rD {
    display: flex;
    justify-content: space-around;
}

.custom-extension-modal_type-selector-button_m1AOu {
    width: 100%;
    cursor: pointer;
    border-bottom: 0.25rem solid var(--ui-tertiary);
    margin: 0 1rem;
    padding: 0.5rem 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-extension-modal_type-selector-button_m1AOu[data-active="true"] {
    border-color: var(--looks-secondary);
}

.custom-extension-modal_type-selector-button_m1AOu:active {
    border-color: var(--looks-transparent);
}

.custom-extension-modal_split_MAlxh {
    min-height: 100%;
    min-width: 4px;
    background-color: var(--ui-secondary);
    margin: 0 15px;
}

.custom-extension-modal_url-input_jC64Z,
.custom-extension-modal_text-code-input_bToYJ {
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0.5rem;
    font-size: inherit;
}

.custom-extension-modal_url-input_jC64Z {
    height: 3rem;
}

.custom-extension-modal_text-code-input_bToYJ {
    min-height: 3rem;
    height: 8rem;
    min-width: 100%;
    max-width: 100%;
    font-family: monospace;
}

.custom-extension-modal_unsandboxed-container_qNk5Y {
    display: flex;
    align-items: center;
}

.custom-extension-modal_unsandboxed-checkbox_QHsd1 {
    margin-right: 0.5rem;
}

.custom-extension-modal_trusted-extension_yDWPb,
.custom-extension-modal_unsandboxed-warning_Crwc3 {
    padding: 0.5rem;
    border-radius: 0.25rem;
}

.custom-extension-modal_trusted-extension_yDWPb {
    background-color: rgba(94, 255, 94, 0.25);
    border: 1px solid green;
}

.custom-extension-modal_unsandboxed-warning_Crwc3 {
    background-color: rgba(255, 81, 81, 0.25);
    border: 1px solid red;
}

.custom-extension-modal_unsandboxed-warning_Crwc3 > *:not(:last-child) {
    display: block;
    margin-bottom: 4px;
}

.custom-extension-modal_button-row_CTGAf {
    display: flex;
    justify-content: flex-end;
}

.custom-extension-modal_load-button_Ywkh3 {
    font: inherit;
    color: inherit;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
    color: white;
    background: var(--looks-secondary);
}

.custom-extension-modal_load-button_Ywkh3:disabled {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-custom-extension-modal/custom-extension-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;IAII,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,+CAA+C;IAC/C,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,6CAA6C;IAC7C,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 990px;\n    margin-top: 50px;\n}\n\n.modal-content-min {\n    max-width: 550px;\n    margin-top: 50px;\n}\n\n.body {\n    background: var(--ui-white);\n    padding: 1.5rem 2.25rem;\n    display: flex;\n    flex-direction: row;\n}\n\n.loadUI {\n    flex: 1;\n    min-width: 300px;\n}\n\n.viewUI {\n    flex: 1;\n    min-width: 300px;\n    overflow-y: auto;\n    max-height: 500px;\n}\n\n.svgList {\n    display: flex;\n    flex-direction: column;\n}\n\n.svgItem{\n    margin-bottom: -75px;\n}\n\n.body p,\n.unsandboxed-container,\n.url-input,\n.text-code-input {\n    margin: 1rem 0;\n    display: block;\n}\n\n.type-selector-container {\n    display: flex;\n    justify-content: space-around;\n}\n\n.type-selector-button {\n    width: 100%;\n    cursor: pointer;\n    border-bottom: 0.25rem solid var(--ui-tertiary);\n    margin: 0 1rem;\n    padding: 0.5rem 0;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.type-selector-button[data-active=\"true\"] {\n    border-color: var(--looks-secondary);\n}\n\n.type-selector-button:active {\n    border-color: var(--looks-transparent);\n}\n\n.split {\n    min-height: 100%;\n    min-width: 4px;\n    background-color: var(--ui-secondary);\n    margin: 0 15px;\n}\n\n.url-input,\n.text-code-input {\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0.5rem;\n    font-size: inherit;\n}\n\n.url-input {\n    height: 3rem;\n}\n\n.text-code-input {\n    min-height: 3rem;\n    height: 8rem;\n    min-width: 100%;\n    max-width: 100%;\n    font-family: monospace;\n}\n\n.unsandboxed-container {\n    display: flex;\n    align-items: center;\n}\n\n.unsandboxed-checkbox {\n    margin-right: 0.5rem;\n}\n\n.trusted-extension,\n.unsandboxed-warning {\n    padding: 0.5rem;\n    border-radius: 0.25rem;\n}\n\n.trusted-extension {\n    background-color: rgba(94, 255, 94, 0.25);\n    border: 1px solid green;\n}\n\n.unsandboxed-warning {\n    background-color: rgba(255, 81, 81, 0.25);\n    border: 1px solid red;\n}\n\n.unsandboxed-warning > *:not(:last-child) {\n    display: block;\n    margin-bottom: 4px;\n}\n\n.button-row {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.load-button {\n    font: inherit;\n    color: inherit;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n    color: white;\n    background: var(--looks-secondary);\n}\n\n.load-button:disabled {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `custom-extension-modal_modal-content_PD3ub`,
	"modalContent": `custom-extension-modal_modal-content_PD3ub`,
	"modal-content-min": `custom-extension-modal_modal-content-min_ntNCd`,
	"modalContentMin": `custom-extension-modal_modal-content-min_ntNCd`,
	"body": `custom-extension-modal_body_SyyBd`,
	"loadUI": `custom-extension-modal_loadUI_M788u`,
	"loadUi": `custom-extension-modal_loadUI_M788u`,
	"viewUI": `custom-extension-modal_viewUI_ifnqN`,
	"viewUi": `custom-extension-modal_viewUI_ifnqN`,
	"svgList": `custom-extension-modal_svgList_pojnv`,
	"svgItem": `custom-extension-modal_svgItem_M8DGF`,
	"unsandboxed-container": `custom-extension-modal_unsandboxed-container_qNk5Y`,
	"unsandboxedContainer": `custom-extension-modal_unsandboxed-container_qNk5Y`,
	"url-input": `custom-extension-modal_url-input_jC64Z`,
	"urlInput": `custom-extension-modal_url-input_jC64Z`,
	"text-code-input": `custom-extension-modal_text-code-input_bToYJ`,
	"textCodeInput": `custom-extension-modal_text-code-input_bToYJ`,
	"type-selector-container": `custom-extension-modal_type-selector-container_UB6rD`,
	"typeSelectorContainer": `custom-extension-modal_type-selector-container_UB6rD`,
	"type-selector-button": `custom-extension-modal_type-selector-button_m1AOu`,
	"typeSelectorButton": `custom-extension-modal_type-selector-button_m1AOu`,
	"split": `custom-extension-modal_split_MAlxh`,
	"unsandboxed-checkbox": `custom-extension-modal_unsandboxed-checkbox_QHsd1`,
	"unsandboxedCheckbox": `custom-extension-modal_unsandboxed-checkbox_QHsd1`,
	"trusted-extension": `custom-extension-modal_trusted-extension_yDWPb`,
	"trustedExtension": `custom-extension-modal_trusted-extension_yDWPb`,
	"unsandboxed-warning": `custom-extension-modal_unsandboxed-warning_Crwc3`,
	"unsandboxedWarning": `custom-extension-modal_unsandboxed-warning_Crwc3`,
	"button-row": `custom-extension-modal_button-row_CTGAf`,
	"buttonRow": `custom-extension-modal_button-row_CTGAf`,
	"load-button": `custom-extension-modal_load-button_Ywkh3`,
	"loadButton": `custom-extension-modal_load-button_Ywkh3`
};
export default ___CSS_LOADER_EXPORT___;
